import React, { useEffect } from "react";
import { FlatList } from "react-native";
import { Box, MainText } from "app/components/common";
import i18n from "@microdoing/shared/i18n";
import CommentSkeleton from "app/scenes/CurrentTrackScreen/DailyFocusScreen/SelectAction/CommentSkeleton";
import { useDispatch, useSelector } from "react-redux";
import {
  getStepSelected,
  getStepSelectedId,
  getUserCampaignStepCommentRequesting,
} from "@microdoing/shared/services/userCampaign/selectors";
import Commentary from "app/components/common/Commentary/Commentary";
import {
  getStepCommentInfoByStepId,
  getStepCommentsByStepId,
} from "@microdoing/shared/services/userCampaign/actions";
import theme from "app/Theme/Theme";

interface IProps {}

const CommentList = ({}: IProps) => {
  const stepSelected = useSelector(getStepSelected);
  const stepCommentRequesting = useSelector(
    getUserCampaignStepCommentRequesting,
  );
  const stepSelectedId = useSelector(getStepSelectedId);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getStepCommentInfoByStepId({ stepId: stepSelectedId }));
    dispatch(getStepCommentsByStepId({ stepId: stepSelectedId }));
  }, [stepSelectedId]);

  const renderItem = ({ item, index }) => (
    <Commentary
      key={index}
      commentary={item}
      marginTop={index === 0 ? "null" : "sm"}
      isLastComment={index === stepSelected.comments.length - 1}
    />
  );

  return (
    <Box
      width="100%"
      height="100%"
      flexGrow={1}
      alignItems="center"
      justifyContent="center"
    >
      {stepSelected?.comments?.length < 1 && !stepCommentRequesting ? (
        <Box width="50%">
          <MainText variant="l4-medium" color="neutral.400" textAlign="center">
            {i18n.t("commentary-no-comments")}
          </MainText>
        </Box>
      ) : (
        <Box flex={1} width="100%">
          <CommentSkeleton isLoading={stepCommentRequesting}>
            <FlatList
              initialNumToRender={5}
              showsVerticalScrollIndicator={true}
              data={stepSelected.comments}
              style={{
                flex: 1,
                display: "flex",
                width: "100%",
                paddingBottom: 50,
                paddingHorizontal: theme.spacing.m,
              }}
              contentContainerStyle={{
                paddingBottom: 70,
                paddingTop: 10,
                width: "100%",
                paddingRight: theme.spacing.m,
              }}
              renderItem={renderItem}
            />
          </CommentSkeleton>
        </Box>
      )}
    </Box>
  );
};

export default CommentList;
